/*
 * vehiclefinder.js  v2  (6 Oct 2026)
 *
 * Header vehicle finder: Brand > Model > Generation > Sub Model > Go.
 * Options are rendered by sections/header.liquid from the Brands and
 * Variants navigation menus (data-item = parent title, data-link = URL).
 *
 * Changes from v1:
 *  1. Safari: non-matching options are REMOVED from the select instead of
 *     hidden (Safari ignores the hidden attribute on <option>). The full
 *     list is captured once at load and each select is rebuilt from it.
 *  2. Changing any dropdown clears every dropdown below it, including the
 *     4th dropdown and its saved value, so Go never uses a stale choice.
 *  3. Saved choices are restored level by level inside the parent's
 *     filtered list, so a title shared by two generations cannot pick the
 *     wrong one. An invalid saved value is dropped with everything below.
 *
 * The inline onchange handlers in header.liquid are unchanged: they still
 * call updateModels(this, level, next) and goToCollection().
 */
(function () {
  var LEVELS = ['brand', 'modal', 'variant', 'subvariant'];
  var els = {};
  var master = {};
  var goBtn = document.getElementById('my_button');
  var clearBtn = document.getElementById('clear_button');

  for (var i = 0; i < LEVELS.length; i++) {
    els[LEVELS[i]] = document.getElementById(LEVELS[i]);
    if (!els[LEVELS[i]]) return; // finder not on this page
  }
  if (!goBtn) return;

  function save(key, val) {
    try {
      if (val) { localStorage.setItem(key, val); } else { localStorage.removeItem(key); }
    } catch (e) { /* storage blocked: finder still works for this page */ }
  }

  function load(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }

  function clearOptions(sel) {
    while (sel.options.length > 1) { sel.remove(1); }
    sel.selectedIndex = 0;
  }

  // The Model select stays visible (as in v1); Generation and Sub Model
  // show only when they have options.
  function setVisible(id, show) {
    if (id === 'modal') { return; }
    els[id].style.display = show ? 'inline-block' : 'none';
  }

  // 1. Capture the server-rendered options once, then empty the selects.
  for (var j = 1; j < LEVELS.length; j++) {
    var id = LEVELS[j];
    var sel = els[id];
    var list = [];
    for (var k = 1; k < sel.options.length; k++) {
      var o = sel.options[k];
      list.push({
        value: o.getAttribute('value') || '',
        item: o.getAttribute('data-item') || '',
        link: o.getAttribute('data-link') || '',
        label: (o.textContent || '').trim()
      });
    }
    master[id] = list;
    clearOptions(sel);
    setVisible(id, false);
  }

  // Rebuild a select with only the options whose parent is parentValue.
  // Exact duplicates (same title and link) are shown once.
  function fill(id, parentValue) {
    var sel = els[id];
    var seen = {};
    var count = 0;
    clearOptions(sel);
    if (parentValue) {
      master[id].forEach(function (d) {
        if (d.item !== parentValue) { return; }
        var key = d.value + '\u0000' + d.link;
        if (seen[key]) { return; }
        seen[key] = true;
        var opt = new Option(d.label, d.value);
        opt.setAttribute('data-item', d.item);
        opt.setAttribute('data-link', d.link);
        sel.add(opt);
        count++;
      });
    }
    setVisible(id, count > 0);
    return count;
  }

  // Clear every level below `level`: options, selection, saved value.
  function resetBelow(level) {
    for (var n = LEVELS.indexOf(level) + 1; n < LEVELS.length; n++) {
      var lid = LEVELS[n];
      clearOptions(els[lid]);
      setVisible(lid, false);
      save(lid, null);
    }
  }

  function hasValue(sel, value) {
    for (var n = 1; n < sel.options.length; n++) {
      if (sel.options[n].value === value) { return true; }
    }
    return false;
  }

  // Go points at the deepest level that has a selection.
  function refreshGo() {
    var href = '#';
    LEVELS.forEach(function (lid) {
      var sel = els[lid];
      var opt = sel.options[sel.selectedIndex];
      if (opt && opt.value && opt.getAttribute('data-link')) {
        href = opt.getAttribute('data-link');
      }
    });
    goBtn.setAttribute('href', href);
    if (clearBtn) { clearBtn.style.display = els.brand.value ? 'inline-block' : 'none'; }
  }

  function onChange(level) {
    var sel = els[level];
    var next = LEVELS[LEVELS.indexOf(level) + 1];
    resetBelow(level);
    save(level, sel.value || null);
    if (next && sel.value) { fill(next, sel.value); }
    refreshGo();
  }

  // Names used by the inline onchange attributes in header.liquid.
  window.updateModels = function (selectItem, option) { onChange(option); };
  window.goToCollection = function () { onChange('subvariant'); };
  window.checkSelectVisibility = function () {}; // v1 name, kept as a no-op

  // 2. Restore saved choices, top down, each within its parent's list.
  for (var r = 0; r < LEVELS.length; r++) {
    var lvl = LEVELS[r];
    var saved = load(lvl);
    if (saved && hasValue(els[lvl], saved)) {
      els[lvl].value = saved;
      if (r + 1 < LEVELS.length) { fill(LEVELS[r + 1], saved); }
    } else {
      for (var q = r; q < LEVELS.length; q++) { save(LEVELS[q], null); }
      break;
    }
  }
  refreshGo();

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      els.brand.selectedIndex = 0;
      save('brand', null);
      resetBelow('brand');
      refreshGo();
    });
  }
})();
